import React from 'react';
import { List, ListItem, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import DashboardIcon from "@mui/icons-material/Dashboard";
import TableChartIcon from "@mui/icons-material/TableChart";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import PersonAddAlt1Icon from "@mui/icons-material/PersonAddAlt1";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import ArchitectureIcon from "@mui/icons-material/Architecture";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import CalculateIcon from "@mui/icons-material/Calculate";
import EngineeringIcon from "@mui/icons-material/Engineering";
import { canAccessMenuRoute, resolveProyectosRolDef } from "../../utils/proyectosRol";

interface NavigationMenuProps {
  open: boolean;
}

type MenuOption = { title: string; icon: React.ReactNode; route: string };

const MENU_CATALOG: MenuOption[] = [
  { title: 'Pagina Principal', icon: <DashboardIcon style={{ fontSize: 20 }} />, route: '/dashboard' },
  { title: 'Gestion Proyectos', icon: <TableChartIcon style={{ fontSize: 20 }} />, route: '/proyectos-panel' },
  { title: 'Crear Proyecto', icon: <AddCircleOutlineIcon style={{ fontSize: 20 }} />, route: '/proyectos-panel/nuevo' },
  { title: 'Calculo de burden', icon: <CalculateIcon style={{ fontSize: 20 }} />, route: '/calculo-burden' },
  { title: 'Asignacion de disenador', icon: <EngineeringIcon style={{ fontSize: 20 }} />, route: '/proyectos-asignacion-disenador' },
  { title: 'Aprobaciones rediseño', icon: <ArchitectureIcon style={{ fontSize: 20 }} />, route: '/proyectos-redisenno' },
  { title: 'Asignacion interventor', icon: <AssignmentIndIcon style={{ fontSize: 20 }} />, route: '/proyectos-asignacion-interventor' },
  { title: 'Crear y gestionar usuarios', icon: <PersonAddAlt1Icon style={{ fontSize: 20 }} />, route: '/usuarios' },
  { title: 'Permisos gestion proyectos', icon: <AdminPanelSettingsIcon style={{ fontSize: 20 }} />, route: '/proyectos-permisos' },
];

const NavigationMenu: React.FC<NavigationMenuProps> = ({ open }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const options = React.useMemo(
    () => MENU_CATALOG.filter((o) => canAccessMenuRoute(o.route)),
    [],
  );

  const rolLabel = React.useMemo(() => resolveProyectosRolDef().label, []);

  const handleNavigation = (route: string) => {
    navigate(route);
  };

  return (
    <List>
      {open && (
        <ListItem sx={{ py: 0.5 }}>
          <ListItemText
            primary={rolLabel}
            primaryTypographyProps={{ variant: 'caption', color: 'text.secondary', fontWeight: 700 }}
          />
        </ListItem>
      )}
      {options.map((option) => (
        <ListItem key={option.route} disablePadding>
          <ListItemButton
            selected={location.pathname === option.route}
            onClick={() => handleNavigation(option.route)}
            sx={{ minHeight: 44 }}
          >
            <ListItemIcon sx={{ minWidth: 40 }}>{option.icon}</ListItemIcon>
            {open && <ListItemText primary={option.title} />}
          </ListItemButton>
        </ListItem>
      ))}
    </List>
  );
};

export default NavigationMenu;
